<template>
<Layout>
    <div class="flex flex-col items-center justify-center min-h-36 md:min-h-96 text-xs lg:text-base">
        <div class="flex flex-wrap">
            <div class="p-1 w-full flex flex-col md:flex-row">
                <div class="relative w-full md:w-1/2 mt-1 mb-1">
                    <p>Add my email to your mailing list</p>
                </div>
                <div class="relative w-full md:w-1/2">
                    <input type="email" id="email" placeholder="email" name="email" class="w-full mailing__input">
                </div>
            </div>
            <div class="p-1">
                <div class="form-control">
                    <label class="cursor-pointer label">
                        <span class="pr-2">Notify me when the shop is updated</span>
                        <input type="checkbox" v-model="isNotifyChecked" class="checked:bg-black ml-2">
                    </label>
                </div>
            </div>
        </div>
        <div class="p-2" v-if="isNotifyChecked">
            <button disabled class="inline-block bg-pink-400 hover:bg-pink-500 focus-within:ring ring-pink-300 text-white text-xs lg:text-base font-semibold text-center rounded-lg outline-none transition duration-100 p-2">Subscribe</button>
        </div>
        <div class="p-2" v-else>
            <button disabled class="inline-block bg-indigo-300 hover:bg-indigo-400 focus-within:ring ring-indigo-300 text-gray text-xs md:text-base font-semibold text-center rounded-lg outline-none transition duration-100 p-2">Unsubscribe</button>
        </div>
    </div>
</Layout>
</template>

<script>
import Layout from '../components/Layout.vue';
export default {
    name: 'MailingPage',
    components: {
        Layout
    },
    data() {
        return {
            isNotifyChecked: true
        }
    }
}
</script>
<style lang="scss">
    .mailing {

        &__wrapper {
            @apply flex flex-col md:flex-row justify-center;
        }

        &__form {
            @apply w-full md:w-1/4 py-6 px-8 m-1 md:m-12 md:mt-6;
        }

        &__input {
            @apply w-full bg-gray-50 text-gray-800 border focus:ring ring-pink-300 rounded outline-none transition duration-100 px-3 py-2 text-xs lg:text-base;
        }
    }
</style>